import { TType } from '../../hooks/useTranslation';

export const FDA_OPTIONS = {
  YES: 'YES',
  NO: 'NO',
  UNDER_DISCUSSION: 'UNDER_DISCUSSION',
};

export const returnRadioButtons = (
  t: TType,
  partOfFda: string | null,
  setPartOfFda,
) => [
  {
    id: 'yes-radio-fda',
    label: t('common.yes'),
    name: `fda-radio-${FDA_OPTIONS.YES}`,
    value: FDA_OPTIONS.YES,
    onChange: () => setPartOfFda(FDA_OPTIONS.YES),
    checked: partOfFda === FDA_OPTIONS.YES,
  },
  {
    id: 'no-radio-fda',
    label: t('common.no'),
    value: FDA_OPTIONS.NO,
    name: `fda-radio-${FDA_OPTIONS.NO}`,
    onChange: () => setPartOfFda(FDA_OPTIONS.NO),
    checked:
      partOfFda === FDA_OPTIONS.NO ||
      partOfFda === null ||
      partOfFda === undefined,
  },
  {
    id: 'under-discussion-radio-fda',
    label: t('common.underDiscussion'),
    name: `fda-radio-${FDA_OPTIONS.UNDER_DISCUSSION}`,
    value: FDA_OPTIONS.UNDER_DISCUSSION,
    onChange: () => setPartOfFda(FDA_OPTIONS.UNDER_DISCUSSION),
    checked: partOfFda === FDA_OPTIONS.UNDER_DISCUSSION,
  },
];
